import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'dashboard',
    component: () => import('../views/dashboard.vue')
  },
  {
    path: '/assetDiscovery',
    name: 'assetDiscovery',
    component: () => import('../views/assetDiscovery.vue'),
  },
  {
    path: '/alertMonitor',
    name: 'alertMonitor',
    component: () => import('../views/alertMonitor.vue')
  },
  {
    path: '/aiModels',
    name: 'aiModels',
    component: () => import('../views/aiModels.vue')
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/settings.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/about.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
